<div class="wrapper-container">
  <q9-toolbar>
    <div q9-left-content>
      <button mat-flat-button (click)="goToMainApp()">
        <mat-icon class="redirect-button-icon" svgIcon="q9-horizontal"></mat-icon>
        App
      </button>
    </div>

    <div q9-right-content>
      <q9-theme-switcher></q9-theme-switcher>
      <q9-notifications></q9-notifications>
      <q9-profile-menu>
        <button mat-menu-item (click)="goToProfile()">Profile</button>
      </q9-profile-menu>
    </div>
  </q9-toolbar>

  <q9-navigation-sidebar>
    <q9-navigation-link
      [ref]="module.path"
      [icon]="module.icon"
      [queryParams]="module.queryParams!"
      *ngFor="let module of modules">
      {{ module.title | translate }}
    </q9-navigation-link>

    <router-outlet></router-outlet>
  </q9-navigation-sidebar>
</div>
